export const formatPhoneWithOptionalIsd = (phoneNumber, isdCode) => {
  const phone = String(phoneNumber ?? "").trim();
  if (!phone) {
    return "";
  }

  const isd = String(isdCode ?? "").trim();
  return isd ? `${isd} ${phone}` : phone;
};

export function foramtNumberToTwoDecimalPlaces(number) {
  const numAmount = parseFloat(number);
  
  if (isNaN(numAmount)) {
    throw new Error('Invalid payment amount format');
  }
  
  if (numAmount <= 0) {
    throw new Error('Payment amount must be greater than zero');
  }
  
  return numAmount.toFixed(2);
}